import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FiltersComponent, RowColumnTooltipPipe } from '@cbre/components';
import { TableComponent } from '@cbre/components';
import { SelectModule } from 'primeng/select';
import { PropertySetsDialogActionsComponent } from '../property-sets-dialog-actions/property-sets-dialog-actions.component';
import { PropertySetStatisticalRendererComponent } from './property-set-table/property-set-statistical-renderer.component';
import { PropertySetFiltersComponent } from './property-set-filters/property-set-filters.component';
import { PropertySetTableComponent } from './property-set-table/property-set-table.component';
import { PropertySetListComponent } from './property-set-list.component';
import { PropertySetListService } from './property-set-list.service';
import { MatIconModule } from '@angular/material/icon';
import { MiqCatalogModule } from '@miq/catalog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableTitleComponent } from '@cbre/components';

@NgModule({
  imports: [
    CommonModule,
    TableComponent,
    FiltersComponent,
    SelectModule,
    // not needed bellow
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    PropertySetsDialogActionsComponent,
    MiqCatalogModule,
    TableTitleComponent,
    RowColumnTooltipPipe,
  ],
  providers: [PropertySetListService],
  declarations: [
    PropertySetListComponent,
    PropertySetFiltersComponent,
    PropertySetTableComponent,
    PropertySetStatisticalRendererComponent,
  ],
  exports: [PropertySetListComponent, PropertySetFiltersComponent, PropertySetTableComponent],
})
export class PropertySetListModule {}
